import { Badge, Button, Modal } from "flowbite-react";
import { customModalTheme } from "styles/customTheme";

export const ModalCreditLimitHistory = ({ isOpen, kitNumber, histories, closeModal }) => {
	const formatDate = (dateString) => {
		return new Intl.DateTimeFormat("en-GB", {
			year: "numeric",
			month: "short",
			day: "2-digit",
			hour: "2-digit",
			minute: "2-digit",
			second: "2-digit",
		}).format(new Date(dateString));
	};

	// Function to render text based on option values and display with Badge
	const renderPolicyText = (option, value) => {
		const badgeConfig = {
			WITH_CREDIT_LIMIT: {
				color: "success",
				text: `Authorised Data: ${value} GB`,
			},
			OPT_OUT: { color: "failure", text: "No Extra Data" },
			UNLIMITED: { color: "failure", text: "UNLIMITED" },
			default: { color: "gray", text: "No Data" },
		};

		const { color, text } = badgeConfig[option] || badgeConfig.default;
		return (
			<Badge color={color} className="inline-block w-fit">
				{text}
			</Badge>
		);
	};

	const renderHistoryData = ({ id, data, done_by, created_at }) => (
		<div key={id} className="rounded-lg border border-gray-600 bg-dark-blue bg-opacity-30 p-4">
			<div className="grid grid-cols-2 gap-4">
				{/* Current Month Policy */}

				<div>
					<p className="font-semibold">Current Month Policy</p>
					{renderPolicyText(data?.current_month_option, data?.current_month_value)}
				</div>

				{/* Permanent Policy */}
				<div>
					<p className="font-semibold">Permanent Policy</p>
					{renderPolicyText(data?.permanent_option, data?.permanent_value)}
				</div>
			</div>

			{/* Done by details */}
			<div className="mt-4">
				<p className="font-semibold">Actioned By:</p>
				<p>
					<span className="text-gray-400">Name: </span>
					<Badge color="info" className="mr-2 inline-block w-fit">
						{done_by?.first_name} {done_by?.last_name}
					</Badge>
				</p>
				<p>
					<span className="text-gray-400">Email: </span>
					<Badge color="primary" className="inline-block w-fit text-gray-300">
						{done_by?.email}
					</Badge>
				</p>
				<p className="text-gray-400 text-sm">
					Created At:{" "}
					<Badge color="primary" className="inline-block w-fit text-gray-300">
						{" "}
						{formatDate(created_at)}
					</Badge>
				</p>
			</div>
		</div>
	);
	return (
		<>
			<Modal show={isOpen} onClose={closeModal} className="" size="4xl" theme={customModalTheme}>
				<Modal.Header className="">
					<span className="text-white">{"Credit Limit History - " + kitNumber}</span>
				</Modal.Header>
				<Modal.Body className="custom-scrollbar">
					<div className="space-y-6">
						{histories?.length ? (
							[...histories]
								.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)) // Sort descending by date
								.map(renderHistoryData)
						) : (
							<p className="text-gray-400">No history available</p>
						)}
					</div>
				</Modal.Body>
				<Modal.Footer>
					<Button
						color="gray"
						onClick={closeModal}
						className="bg-gray-700 text-white hover:bg-gray-800"
						size={"sm"}
					>
						Close
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};
